export const BYO_ADD_SELECTION = 'BYO_ADD_SELECTION';
export const BYO_PROCESS_SELECTION = 'BYO_PROCESS_SELECTION';
export const BYO_REMOVE_SELECTION = 'BYO_REMOVE_SELECTION';
export const BYO_ODDS_FORMAT = 'BYO_ODDS_FORMAT';
export const BYO_EDIT_SELECTIONS = 'BYO_EDIT_SELECTIONS';
export const BYO_MARKETS_REQUEST = 'BYO_MARKETS_REQUEST';
export const BYO_MARKETS_SUCCESS = 'BYO_MARKETS_SUCCESS';
export const BYO_MARKET_FETCHING_STARTED = 'BYO_MARKET_FETCHING_STARTED';
export const BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE = 'BYO_SLIP_ADD_SELECTION_TO_PROCESSING_QUEUE';
export const BYO_SLIP_ADD_SELECTION_TO_STORE = 'BYO_SLIP_ADD_SELECTION_TO_STORE';
export const BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE = 'BYO_SLIP_REMOVE_SELECTION_FROM_PROCESSING_QUEUE';
export const BYO_SLIP_REMOVE_SELECTION_FROM_STORE = 'BYO_SLIP_REMOVE_SELECTION_FROM_STORE';
export const BYO_SLIP_ADD_PRICE_TO_STORE = 'BYO_SLIP_ADD_PRICE_TO_STORE';
export const BYO_SLIP_REMOVE_PRICE_FROM_STORE = 'BYO_SLIP_REMOVE_PRICE_FROM_STORE';
export const BYO_SLIP_CLEAR_ALL = 'BYO_SLIP_CLEAR_ALL';
export const BYO_SLIP_SELECTION_INCOMPATIBLE_ERROR = 'BYO_SLIP_SELECTION_INCOMPATIBLE_ERROR';
export const BYO_ERRORS_SHOW_EVENT_LEVEL = 'BYO_ERRORS_SHOW_EVENT_LEVEL';
export const BYO_ERRORS_HIDE_EVENT_LEVEL = 'BYO_ERRORS_HIDE_EVENT_LEVEL';
export const BYO_ERRORS_CLEAN_ALL = 'BYO_ERRORS_CLEAN_ALL';
export const BYO_SLIP_EXPANDED = 'BYO_SLIP_EXPANDED';
export const BYO_ADD_TO_BETSLIP = 'BYO_ADD_TO_BETSLIP';
export const BYO_ADD_TO_BETSLIP_ERROR = 'BYO_ADD_TO_BETSLIP_ERROR';
export const BYO_PROCESSING_TO_BETSLIP = 'BYO_PROCESSING_TO_BETSLIP';
export const BYO_OPEN_MODAL = 'BYO_OPEN_MODAL';
export const BYO_CLOSE_MODAL = 'BYO_CLOSE_MODAL';
export const BYO_OPENING_FROM_CAMPAIGN = 'BYO_OPENING_FROM_CAMPAIGN';
export const BYO_SET_USER_LOGIN = 'BYO_SET_USER_LOGIN';
export const BYO_SET_WAITING_FOR_LOGIN = 'BYO_SET_WAITING_FOR_LOGIN';
export const BYO_ERROR_BUILDSLIP = 'BYO_ERROR_BUILDSLIP';
export const BYO_SET_EDIT_ID = 'BYO_SET_EDIT_ID';
export const BYO_ADD_FAVOURITE = 'BYO_ADD_FAVOURITE';
export const BYO_REMOVE_FAVOURITE = 'BYO_REMOVE_FAVOURITE';
